import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import { Button, Modal } from 'hljd'
import { PreviewModal } from 'hlj-components'
import Store from './store'
import { MY_COUPON_PATH_A, SHOP_PRODUCTS_PATH_A } from '@constant'
import Img from '@UI/Img'
import { statisticPoster } from '@util'

@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  componentDidMount() {
    this.store.getCouponPoster()
  }

  render() {
    const {
      visible,
      closePopup,
      poster,
      successVisible,
      cancelSuccessModal,
      successMsg,
      getCoupon
    } = this.store

    return (
      <Fragment>
        {visible ? (
          <PreviewModal visible={visible} onCancel={closePopup}>
            <img
              src={poster.image_path}
              onClick={() => {
                getCoupon()
                statisticPoster(poster.id)
              }}
            />
          </PreviewModal>
        ) : null}

        <Modal
          title={null}
          footer={null}
          closable={false}
          visible={successVisible}
          onCancel={cancelSuccessModal}
        >
          <div className="text-center">
            <div>
              <Img
                src="//qnm.hunliji.com/o_1cnr4fpoces91b0p140k1tmpdtjo.png"
                width="58"
                height="62"
              />
            </div>

            <div
              style={{
                fontWeight: 'bold',
                fontSize: 28
              }}
            >
              领取成功
            </div>
            <div
              style={{
                fontSize: 18,
                marginBottom: 40,
                color: '#999'
              }}
            >
              {successMsg}
            </div>

            <div>
              <Button
                onClick={() => window.open(MY_COUPON_PATH_A)}
                style={{ marginRight: 30 }}
              >
                查看优惠券
              </Button>
              <Button
                type="primary"
                onClick={() => window.open(SHOP_PRODUCTS_PATH_A)}
              >
                立即使用
              </Button>
            </div>
          </div>
        </Modal>
      </Fragment>
    )
  }
}
